module.exports = __webpack_public_path__ + "img/IMG_8928.b0836da0.jpg";